export const INFO_ALERT = {
  addGiftCard: 'Only The Home Depot gift cards can be saved to account.'
};

export const ERROR = {
  technicalError: 'Sorry, we\'re experiencing technical difficulties. Please try again later.',
  genericError: 'Something went wrong. Refresh the page and try again.',
  disableCheckBalance:
    'Gift card balances and services are unavailable at this time. Please try again later.',
  serviceUnavailable: 'Gift Cards Unavailable.'
};

export const FAQ_TITLE = 'Managing Gift Cards FAQ';
